<template>
   <div
      class="
         file-preview-item
         bg-light
         p-3
         rounded
         d-flex
         justify-content-between
         align-items-center
         file-preview
      "
   >
      <div class="d-flex align-items-center">
         <div class="file-info">
            <img src="@/assets/img/file.png" style="height: 30px; width: 25px" alt="file" />
            <div>
               <strong class="ml-2 file-name">{{ fileName }}</strong>
               <div class="text-muted ml-2" style="font-size: 11px">
                  File size: {{ formatSize(fileSize) }}
               </div>
            </div>
         </div>
      </div>

      <div class="d-flex align-items-center justify-content-end file-metadata-row">
         <div class="file-metadata">
            <b-form-group
               label="Select period"
               label-class="mb-0 label-description"
               class="period-class"
            >
               <StudyPeriodSelect
                  v-model="localPeriodId"
                  :ident="ident"
                  :disabled="disabled"
                  :active-study="!!activeStudyId"
                  emptyText="Select period"
               />
            </b-form-group>

            <b-form-group
               label="Description"
               label-class="mb-0 label-description"
               class="description-class"
            >
               <b-form-input
                  v-model="localDescription"
                  :disabled="disabled"
                  placeholder="Description"
               />
            </b-form-group>
         </div>

         <div v-if="canDeleteFiles" class="right d-flex align-items-center ml-3">
            <button
               type="button"
               class="icon-btn trash-icon-btn"
               aria-label="Delete"
               @click="$emit('delete')"
            >
               <b-icon style="width: 1rem; height: 1rem" icon="trash" />
            </button>
         </div>
      </div>
   </div>
</template>

<script>
import {mapGetters} from 'vuex';
import StudyPeriodSelect from '@/components/forms/StudyPeriodSelect.vue';

export default {
   name: 'FileUploadPreviewItem',
   components: {StudyPeriodSelect},
   props: {
      file: {
         type: Object,
         required: true,
      },
      ident: {
         type: String,
         default: 'upload-document-preview',
      },
      disabled: {
         type: Boolean,
         default: false,
      },
      canDeleteFiles: {
         type: Boolean,
         default: true,
      },
   },
   data() {
      return {
         localPeriodId: this.file.periodId ?? null,
         localDescription: this.file.description ?? '',
      };
   },
   computed: {
      ...mapGetters({
         activeStudyId: 'companies/activeStudyId',
      }),
      fileName() {
         return this.file.name ?? this.file.file?.name ?? '';
      },
      fileSize() {
         return this.file.size ?? this.file.file?.size ?? 0;
      },
   },
   methods: {
      formatSize(bytes) {
         const kb = bytes / 1024;
         return kb < 1024 ? `${kb.toFixed(1)}kB` : `${(kb / 1024).toFixed(1)}MB`;
      },
      emitChange() {
         this.$emit('change', {
            ...this.file,
            periodId: this.localPeriodId,
            description: this.localDescription,
         });
      },
   },
   watch: {
      localPeriodId() {
         this.emitChange();
      },
      localDescription() {
         this.emitChange();
      },
      file: {
         deep: true,
         handler(newVal) {
            this.localPeriodId = newVal.periodId ?? null;
            this.localDescription = newVal.description ?? '';
         },
      },
   },
};
</script>

<style scoped lang="scss">
.file-preview-item {
   margin-bottom: 10px;
}

.file-name {
   font-size: 13px;
}

.file-metadata-row {
   gap: 0.75rem;
}

.file-metadata {
   min-width: 260px;
   width: 420px;
   display: flex;
   gap: 0.5rem;
}

.icon-btn {
   border: none;
   background: transparent;
   color: #98a2b3;
   display: inline-flex;
   align-items: center;
   justify-content: center;
   transition: background 0.12s ease, color 0.12s ease;
   cursor: pointer;
}

.icon-btn:hover {
   background: #eef2f7;
   color: #667085;
}

.trash-icon-btn:hover {
   color: $danger;
}

.description-class,
.period-class {
   font-size: 12px;
   margin-bottom: 0px !important;
}

.description-class {
   flex: 2;
}

.period-class {
   flex: 1;
}

.file-info {
   display: flex;
}

@media (max-width: 991px) {
   .file-preview {
      flex-direction: column;
   }

   .file-info {
      margin-bottom: 0.75rem;
   }

   .file-metadata-row {
      width: 100%;
   }
}

::v-deep .label-description {
   font-size: 11px;
   color: grey;
   font-weight: normal;
   padding-bottom: 0px !important;
}

::v-deep .form-control,
::v-deep .custom-select {
   font-size: 12px !important;
   font-weight: normal !important;
}
</style>
